import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
 
import { Redirect  } from 'react-router-dom';
import Button from '@mui/material/Button';
import axios from 'axios';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';  
import SearchIcon from '@mui/icons-material/Search';
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  
import TableRow from '@mui/material/TableRow';  
import TableHead from '@mui/material/TableHead';  
import TableCell from '@mui/material/TableCell'; 
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';
import AddLedger from './AddLedger';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [
{ id: 'le_code', numeric: false,  label: 'Account Number' },
{ id: 'le_ledgername', numeric: false,  label: ' Ledger Name' },
{ id: 'le_category', numeric: false,  label: 'Category' },

{ id: 'le_categorygroup', numeric: false,  label: 'Category Groups' },
{ id: 'le_displayname', numeric: false,  label: 'Display Name' },

{ id: '', numeric: false,  label: '' },

]

function EnhancedTableHead(props) {
  const {  order, orderBy,   onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  
  
return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));


const EnhancedTableToolbar = props => {
const classes = useToolbarStyles();
const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
 
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  
})
)


export default class AdminLedger extends Component {
	constructor(props) {
    super();
this.state = {
redirect:false,pagename:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:20,rowsPaging:[],
	 search:'',id:'',order:'desc' ,orderBy:'le_id',ledgerdata:[],le_id:0,btndisabled:false,
submitbtn:"Submit",namesearch:'',searchbtn:"search",searchbtndisabled:false,ledgerarray:[],name:'', 

      }
	   this.updatledgerParent = this.updatledgerParent;
	 };
	 
	 updatledgerParent = (text) => {this.apicall(this.state.page,this.state.rowsPerPage);}
	 
	
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:20,
	  prevpage:0,ledgerdata:[],
	  
	
    });
	
}
	
  myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});

 }



componentWillMount() {
		document.title = "Isifol - Chart of Accounts";
		 if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
		  this.apicall(this.state.page,this.state.rowsPerPage); 		
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
	
 let strname="Chart of Accounts ";
		   
	 this.props.parentdasCallback(
            strname+"~"
        );
		
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  
	}
	
	handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 
	
	PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=16')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        this.apicall(this.state.page,this.state.rowsPerPage); 	

      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}

apicall(page,rowsPerPage){
axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_ledgername='+this.state.namesearch+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&le_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => {  

		if(resp.data.length>0){
		
			this.setState({  
			  ledgerdata: resp.data, 
               			  
			   totaldata:parseInt(resp.data[0].count),
			   
			},()=>{console.log(this.state.ledgerdata);});
			
			let cnt=this.state.totaldata;
			let page=this.state.rowsPerPage;
			 cnt=Number(cnt)/Number(page);
		   let copy=[];
		
			for (var key=0;key<cnt;key++) { 
			
				let val=(Number(key)*5)+5;
				
			 copy.push(val)
     }
	   this.setState({rowsPaging:copy,searchbtndisabled:false,searchbtn:"Search"});
	}
	 else{
		   this.setState({ledgerdata:[],totaldata:0},()=>{console.log(this.state.ledgerdata);});
	 }
   
    });

}


handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'desc';
  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'desc'
   
  });
};

handleChangePage = (event, newPage) => {  
 let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  
  
   deleteLedger(leid){  
  
		let r = window.confirm("Do you really want to Delete?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','delete')					 
					 formData.append('le_id',leid)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxledger.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
				  
					
					
							});
		 }
 }
 
  
handleSearch=()=>{
	  
  this.apicall(this.state.page,this.state.rowsPerPage); 
} 
 
 
 handleClickdiscard = (e) => {
 
  this.setState({open:!this.state.open, name:'',le_id:0,bankarray:[],namesearch:'',
	 });
		};
 
 
 

 Ledgeraddbox(val){
        this.setState({ le_id: val },()=>{this.refs.AddLedger.handleClickOpen()});  
  
        
		 
      }
 
 render() {
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  return (
   <React.Fragment>

  <div className="searchbox">
<ul>

<li><p>Search</p>
<p><TextField
            //variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={this.state.namesearch}
            id="namesearch"
           variant="outlined"
            name="namesearch" onChange={this.myChangeHandler}
            autoComplete="namesearch"
			placeholder="Search"
            
			 InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
		  </p>
</li>
<li> <p>&nbsp;</p><p><Button
            type="submit"
            halfWidth
            variant="contained" 
			disabled={this.state.searchbtndisabled}
           id="searchform" 
            className="frmSecondarybtn"
			onClick={this.handleSearch}
			
          >
           {this.state.searchbtn}
          </Button></p></li>

</ul>
</div>
     <div className="addandbacbtn">
	  <NavLink   className="frmSecondarybtn"  onClick={()=>{this.Ledgeraddbox(0)}}>New Ledger Account</NavLink>

   </div>
   <div class="clear"></div>

   <AddLedger ref="AddLedger" id={this.state.le_id} updateledger={this.updatledgerParent}/>	
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  

					  
					   <EnhancedTableHead
             
              
              order={this.state.order}
              orderBy={this.state.orderBy}
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.ledgerdata.length}
            />
			
			
			
                      <TableBody>

                     {stableSort(this.state.ledgerdata, getSorting(this.state.order, this.state.orderBy)).map((item,index) =>{
 if(this.state.totaldata>0)					
	 {   return ( <React.Fragment>
 <TableRow key={index} >

	
	<TableCell>{item.le_code}</TableCell>

<TableCell>{item.le_ledgername}</TableCell>
<TableCell>{item.category}</TableCell>
<TableCell>{item.le_categorygroup}</TableCell>
<TableCell>{item.le_displayname}</TableCell>

	
<TableCell align="left">
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Ledgeraddbox(item.le_id)} }endIcon={<EditIcon />}>
Edit
</Button>  

	
 </TableCell>

 </TableRow>


				</React.Fragment>	
				);
	 }	
						 else{
					 return ( <React.Fragment>
				<TableRow  >
<TableCell colspan="5">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				</React.Fragment>	
				);	
				}
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
          rowsPerPageOptions={[50,100,200,300,400]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}    
      />    
  </Paper>
   
 

   
 </React.Fragment>

		  );
  }	
   
}